"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPathname = void 0;
const static_generation_async_storage_external_1 = require("next/dist/client/components/static-generation-async-storage.external");
const has_base_path_1 = require("next/dist/client/has-base-path");
const remove_base_path_1 = require("next/dist/client/remove-base-path");
const server_getter_in_client_component_error_1 = require("./server-getter-in-client-component-error");
function getPathname() {
    (0, server_getter_in_client_component_error_1.serverGetterInClientComponentError)('getPathname');
    const store = static_generation_async_storage_external_1.staticGenerationAsyncStorage.getStore();
    if (!store)
        return null;
    const { urlPathname } = store;
    const url = new URL(urlPathname, 'http://n');
    const pathname = (0, has_base_path_1.hasBasePath)(url.pathname)
        ? (0, remove_base_path_1.removeBasePath)(url.pathname)
        : url.pathname;
    return pathname;
}
exports.getPathname = getPathname;
